import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '@telus-uds/components-web';
import { RICH_TEXT_TYPES } from '../../types';
var BLOCKS = RICH_TEXT_TYPES.BLOCKS;
export var buildHeadingFunctions = function (_a) {
    var heading = _a.heading, alignText = _a.alignText, headingSize = _a.headingSize;
    var headingFunctions = {};
    var headingNums = Array.from({ length: 6 }, function (_, i) { return i + 1; });
    headingNums.forEach(function (num) {
        var tag = "h".concat(num);
        var key = BLOCKS["HEADING_".concat(num)];
        headingFunctions[key] = function (_node, children) {
            var _a;
            return (_jsx(Typography, { block: true, heading: tag, variant: { colour: heading, size: (_a = headingSize === null || headingSize === void 0 ? void 0 : headingSize[tag]) !== null && _a !== void 0 ? _a : tag }, align: alignText, children: children }));
        };
    });
    return headingFunctions;
};
